import { pick } from 'lodash';
import * as yup from 'yup';
import { validateSwedishSsn } from '../../../../utils/validation';
import { validatePerson } from '../../../../utils/validation/person';

export const proxiesValidationSchema = yup.object().shape({
  socialSecurityNumber: validateSwedishSsn(true),
  ...pick(validatePerson, 'firstName', 'lastName'),
});
